import {Ohelper_view_assets as assets, config_app} from "hind/core";
import {Config_view} from "hind//workspace";
import {get_external_link, get_duration_block} from "../utils/icon";

const assets_url = config_app.url_assets + "/img/";

export default function home(data) {
    const section_ico = {
        'coordinates'     : 'user-solid.svg',
        'job_typologies'  : 'palette-solid.svg',
        'skills'          : 'brain-solid.svg',
        'trainings'       : 'person-chalkboard.svg',
        'asso_projects'   : 'circle-nodes-solid.svg',
        'perso_projects'  : 'lightbulb-solid.svg',
        'freelance_xp'    : 'person-walking-luggage-solid.svg',
        'employee_xp'     : 'user-tie-solid.svg',
        'schooling'       : 'user-graduate-solid.svg',
        'perso_activities': 'gem-regular.svg'
    };

    return `
        <div id="newsletter_subscription_wrapper" data-popin-to-print="${data.popin_to_print}"></div>
        <nav id="home_menu" class="home__menu">
             <p id="home-menu-coordinates" class="home__menu__coordinates">
                <a href="#coordinates">${assets.get(section_ico.coordinates, 'img')}</a>
            </p>
             <p id="home-menu-typologies" class="home__menu__typologies">
                <a href="#job_typologies">${assets.get(section_ico.job_typologies, 'img')}</a>
            </p>
             <p id="home-menu-skills" class="home__menu__skills">
                <a href="#skills">${assets.get(section_ico.skills, 'img')}</a>
            </p>
             <p id="home-menu-trainings" class="home__menu__trainings">
                <a href="#trainings">${assets.get(section_ico.trainings, 'img')}</a>
            </p>
            <p id="home-menu-asso-projects" class="home__menu__asso-projects">
                <a href="#asso_projects">${assets.get(section_ico.asso_projects, 'img')}</a>
            </p>
             <p id="home-menu-perso-projects" class="home__menu__perso-projects">
                <a href="#perso_projects">${assets.get(section_ico.perso_projects, 'img')}</a>
            </p>
             <p id="home-menu-freelance-xp" class="home__menu__freelance-xp">
                <a href="#freelance_xp">${assets.get(section_ico.freelance_xp, 'img')}</a>
            </p>
             <p id="home-menu-employees-xp" class="home__menu__employees-xp">
                <a href="#employee_xp">${assets.get(section_ico.employee_xp, 'img')}</a>
            </p>
            <p id="home-menu-schooling" class="home__menu__schooling">
                <a href="#schooling">${assets.get(section_ico.schooling, 'img')}</a>
            </p>
            <p id="home-menu-perso-activities" class="home__menu__perso-activities">
                <a href="#perso_activities">${assets.get(section_ico.perso_activities, 'img')}</a>
            </p>
            <p id="home__menu__newsletter" class="home__menu__newsletter">
                ${assets.get('envelope-solid.svg', 'img')}
            </p>
        </nav>
        <div id="home_menu_button" class="home-menu-button">
             <div id="menu-toggle" class="cross">
                <span></span>
             </div>
        </div>
        
        <section id="home-content">
            <div id="coordinates" class="coordinates trigger-on-scroll" data-reference="coordinates">
                <div>
                    <div>
                        <h1>Matthieu BARBARESCO</h1>
                        <p class="h-0 rm-md">&nbsp;</p>
                        <p>${Config_view.get().my_address}</p>
                        <p><a class="external_link" href="tel:${Config_view.get().my_phone_link}">${Config_view.get().my_phone_label}</a></p> 
                        <p><a class="external_link" href="mailto:${Config_view.get().my_email}">${Config_view.get().my_email}</a></p>
                        <p class="coordinates__additionals-links">
                            <a class="external_link" target="_blank" rel="nofollow" href="https://github.com/matthieubarbaresco/">${assets.get({
        name : "github.svg",
        alt  : "Lien GitHub",
        class: ""
    }, "img")}</a>                        
                            <a class="external_link" target="_blank" rel="nofollow" href="https://www.linkedin.com/in/matthieu-barbaresco-14956b37/">${assets.get({
        name : "linkedin.svg",
        alt  : "Lien Linkedin",
        class: "coordinates__linkedin-ico"
    }, "img")}</a><a class="external_link" target="_blank" href="${config_app.url_documents}${Config_view.get().pdf_prefixes.fr}_MATTHIEU_BARBARESCO_CV_DEVELOPPEUR_WEB.pdf">${assets.get({
        name : "file-pdf-solid.svg",
        alt  : "Lien CV FR en PDF",
        class: "coordinates__pdf-ico"
    }, "img")}<span>FR</span>
                            </a>
                            <a class="external_link" target="_blank" href="${config_app.url_documents}${Config_view.get().pdf_prefixes.en}_MATTHIEU_BARBARESCO_RESUME_WEB_DEVELOPER.pdf">${assets.get({
        name : "file-pdf-solid.svg",
        alt  : "Lien CV EN en PDF",
        class: "coordinates__pdf-ico"
    }, "img")}<span>EN</span>
                            </a>
                        </p>
                        <p style="height: 5px;"></p> 
                    </div>
                    <div class="my-photo">
                        ${get_my_photo_content()}
                    </div>
                </div>
            </div>
            <div class="titles">
                <strong>Conception API / BDD</strong>
                <strong>Développement Back-end & Front-end</strong>
                <strong>Pourvoyeur de conseils / non donneur de leçons</strong>
            </div>
            <article id="job_typologies" class="job-typologies trigger-on-scroll" data-reference="typologies">
                <div>
                    <h2>${assets.get({
        name   : section_ico.job_typologies,
        'class': 'section-ico'
    }, 'img')}Typologie des interventions</h2>
                    <ul>
                        <li>
                            Gestion d’un projet web (fonctionnel et technique), encadrement technique, formation,
            recrutement de free-lance.
                        </li>
                        <li>
                            Modélisation de données, conception NoSQL / SQL / API REST / applicative, wireframing.
                        </li>
                        <li>
                            Microservice sur AWS LAMBDA.
                        </li>
                        <li>
                            WordPress : e-commerce, espace privé, thème, plugin, API, composants Gutenberg.
                        </li>
                        <li>
                            TDD avec PHP UNIT.
                        </li>
                        <li>
                            Installation et sécurisation environnement LAMP, LEMP, Node.js, CADDY.
                        </li>
                        <li>
                            Maintenance applicative.
                        </li>
                        <li class="firefighter">
                            Pompier / Commando.
                        </li>
                    </ul>
                </div>
            </article>
            <div id="skills" class="skills trigger-on-scroll" data-reference="skills">
                <h2>${assets.get({
        name   : section_ico.skills,
        'class': 'section-ico'
    }, 'img')}Compétences
                </h2>
                
                <article class="experience_skills">
                    <div class="experience_skills__grid">
                        <div>
                            <h3>Avant-vente</h3>
                            <p>Prise des besoins, conseil, propositions fonctionnelles et techniques, chiffrage.</p>
                        </div>
                        <div>
                            <h3>Conception</h3>
                            <p>Maquette fonctionnelle, dictionnaire de données, schéma relationnel, diagramme utilisateur, diagramme de séquences, micro-service.</p>
                        </div>
                        <div>
                            <h3>Production</h3>
                            <p>Écriture des fonctionnalités, écriture des scénarios de contrôle qualité, gestion du projet GIT, relecture des codes à livrer / recette technique.</p>
                        </div>
                        <div>
                            <h3>Documentation</h3>
                            <p>Rédaction et gestion des documentations techniques et fonctionnelles.</p>
                        </div>
                        <div>
                            <h3>Mise en ligne</h3>
                            <p>Gestion des numéros de version, informations aux équipes techniques et fonctionnelles sur les nouveautés mises en ligne.</p>
                        </div>
                    </div>
                </article>
                
                <hr />
                
                <article class="technicals_skills">
                    <div class="technicals_skills__grid">
                        <div>
                            <h3>Systèmes</h3>
                            
                            <ul>
                                <li>Debian</li>
                            </ul>
                        </div>
                        <div>
                            <h3>Languages</h3>
        
                            <ul>
                                <li>PHP</li>
                                <li>JavaScript ES</li>
                                <li>SQL</li>
                                <li>SHELL linux</li>
                                <li>CSS</li>
                                <li>SASS</li>
                                <li>C#</li>
                                <li>TypeScript</li>
                            </ul>
                        </div>
                        <div>
                            <h3>SGBD</h3>
                            
                            <ul>
                                <li>MariaDB</li>
                                <li>MySQL</li>
                                <li>MongoDB</li>
                                <li>DynamoDB</li>
                                <li>SQL Server</li>
                            </ul>
                        </div>
                        <div>
                            <h3>Frameworks, librairies</h3>
                            
                            <ul>
                                <li>Serverless</li>
                                <li>Express JS</li>
                                <li>Phalcon</li>
                                <li>React JS</li>        
                                <li>D3.js</li>
                                <li>CKEditor5</li>
                                <li>DevExtreme ReactJS</li>
                            </ul>
                        </div>
                        <div>
                            <h3>Paiement, mail, IA</h3>
                            
                            <ul>
                                <li>Stripe</li>
                                <li>Mailjet</li>
                                <li>OpenAI</li>
                            </ul>
                        </div>
                        <div>
                            <h3>CMS</h3>
                            
                            <ul>
                                <li>WordPress</li>
                            </ul>
                        </div>
                        <div>
                            <h3>Outils divers & variés</h3>
                            
                            <ul>
                                <li>Claude</li>
                                <li>Microsoft Copilot</li>
                                <li>GIT</li>
                                <li>WebPack</li>
                                <li>Vite</li>
                                <li>NPM</li>
                                <li>NPX</li>
                                <li>Composer</li>
                                <li>Let's encrypt</li>
                                <li>AWS Lambda</li>
                                <li>Supervisord daemon</li>
                                <li>PM2</li>    
                            </ul>
                        </div>
                        <div>
                            <h3>Logiciels</h3>
                            
                            <ul>
                                <li>PHPStorm</li>
                                <li>Slack</li>
                                <li>Jira</li>
                                <li>Confluence</li>
                                <li>Postman</li>
                                <li>Gogs</li>
                                <li>FramaGit</li>
                                <li>GitLab</li>
                                <li>GitHub</li>
                                <li>DataGrip</li>
                            </ul>
                        </div>
                        <div>
                            <h3>Serveurs, services</h3>
                            
                            <ul>
                                <li>LAMP</li>
                                <li>LEMP</li>
                                <li>Node.js</li>
                                <li>Caddy</li>
                            </ul>
                        </div>
                    </div>
                </article>
                
                <hr />
                
                <article class="langs">
                    <h2>Langues</h2>
                    <p>Français : Niveau C2</p>
                    <p>Anglais : Niveau C1</p>
                </article>
            </div>
            <div class="experiences">
                <article id="trainings" class="experiences__typeof trigger-on-scroll" data-reference="trainings">
                    <h2>${assets.get({
        name   : section_ico.trainings,
        'class': 'section-ico'
    }, 'img')}Formation personnelle</h2>
                    
                    <section class="experiences__experience">
                        <h3>Formation d’anglais : ILAC Toronto + wwoofing en Ontario</h3>
                        ${get_duration_block("04/2025 - 10/2025")}
                        <p>Cours d’anglais au niveau C1 pendant quatre mois et le dernier mois en C2.</p>
                        <p>Toutes les deux semaines, nous passions un examen de type Cambridge.</p>
                        <p>Cette formation s’est déroulée à Toronto en famille d’accueil. Ceci dans le but de compléter mes cours par une immersion dans une culture anglophone.</p>
                        <p>Après cette école, je suis parti faire un wwoofing d’un mois dans une ferme de l’Ontario afin de me frotter à d’autres accents et usages de l’anglais, tout en continuant d’apprendre avec joie diverses techniques d’agriculture dans un cadre exceptionnel.</p>
                    </section>
                </article>
                <article id="asso_projects" class="experiences__typeof trigger-on-scroll" data-reference="asso-projects">
                    <h2>${assets.get({
        name   : section_ico.asso_projects,
        'class': 'section-ico'
    }, 'img')}Conception et programmation - Bénévolat</h2>
                    
                    <section class="experiences__experience">
                        <h3>Rhizome Marseille</h3>
                        ${get_duration_block("05/2024 - 05/2025")}
                        <p class="experiences__experience_tags">Mots-clés : <strong>JS ES, SCSS, Caddy, Node.js, D3js, Open layers, Webpack</strong></p>
                        <p>Création d’une application afin de mettre en valeur les initiatives sociales et solidaires à Marseille, que je nomme ici les entités.</p>
                        <p>Création d’un arbre hiérarchique dans lequel on navigue pour afficher les taxonomies et les entités, affichées sous forme de nœuds et de feuilles. Certaines entités sont aussi des nœuds.
                        </p>
                        <p>Un clic sur une entité ouvre sa fiche explicative. Chaque entité a ainsi un texte et diverses coordonnées.</p>
                        <p>Une recherche est disponible. Selon les lettres saisies elle affiche une liste d’entités et de taxonomies. Au clic sur un item de la recherche, le graphe se replie puis déplie jusqu’au nœud ou la feuille concerné(e), et sa fiche descriptive, si elle existe, s’ouvre ensuite.</p>
                        <p>C’est une application statique.</p>
                        <p>Installation et maintenance du serveur : un VPS chez OVH tournant sur Debian. Utilisation de Caddy Web Server.</p>
                        <p class="bold">Rôles :</p>
                        <ul>
                            <li>Concevoir et réaliser techniquement l’application. La mettre en ligne et assurer sa maintenance applicative.</li>
                            <li>Création et maintenance du déploiement automatisé via des scripts SHELL déclenchés depuis Framagit.</li>
                            <li>Création de démo de cartographie, graphe de force, heatmap et hierarchy tree.</li>
                            <li>Conception fonctionnelle en collaboration avec les autres membres de l’association.</li>
                            <li>Développement et déploiement d’une version de base montrant un arbre hiérarchique dans lequel on peut naviguer facilement et une recherche simple (le tout est responsive).</li>
                            <li>Intégration en SASS.</li>
                            <li>Développement: Node.JS, SCSS, Webpack avec <a href="#perso_projects">le framework HIND</a>, D3js.</li>
                            <li>Mise en production: Installation d’un serveur Caddy chez OVH.</li>
                            <li>Présentation des travaux accomplis et prise de toutes critiques pour améliorer l’application.</li>
                            <li>Réflexions sur les futures utilisations et besoins. Sur l’avenir de ce type d’outils.</li>
                        </ul>
                    </section>
                    <section class="experiences__experience">
                        <h3><a target="_blank" class="external_link" href="https://permamontreuil.fr/">PermaMontreuil
                        ${get_external_link()}
                        </a></h3>
                        ${get_duration_block("10/2023 - 03/2025")}
                        <p class="experiences__experience_tags">Mots-clés : <strong>WordPress, PHP, JS, CSS, React, formation WordPress, Cron</strong></p>
                        <p>Création d’un site web pour la communication de l’association PermaMontreuil.</p>
                        <p>Il présente des ressources sur la permaculture, ainsi que l’événementiel et les publications de
                        l’association.</p>
                        <p>Il permet de s’enregistrer en tant que bénévole, stand, animateur-ice d’atelier / animation pour "Les Estivales de la Permaculture", le festival dédiée à la permaculture lancé depuis 2014 par l'association.</p>
                        <p>Une fois réalisé, je me suis chargé de migrer les anciens contenus dessus.</p>
                        <p class="bold">Rôles :</p>
                        <ul>
                            <li>Concevoir et réaliser le site web. Le mettre en ligne et assurer sa maintenance applicative.</li>
                            <li>Proposer un paramétrage simple et fourni des événements (fréquence, dates, heures, organisateurs…).</li>
                            <li>Faciliter les inscriptions - et leurs traitements - au festival en tant que bénévole, stands, animateurs-ices d’ateliers.</li>
                            <li>Surcharge du thème « accelerate » via un thème enfant.</li>
                            <li>Développement : WordPress, JS, CSS, CRON JOB, librairie Calendar.js, React Js (composant Gutenberg).</li>
                            <li>Mise en production: Installation d’un serveur LAMP chez OVH.</li>
                            <li>Formation à l’utilisation de l’outil. Création d'un guide d'utilisation.</li>
                            <li>Migration des contenus entre ancienne et nouvelle plateforme.</li>
                            <li>Maintenance évolutive, aide à la création de contenus, édition d'articles.</li>
                        </ul>
                    </section>
                </article>
                <article id="perso_projects" class="experiences__typeof trigger-on-scroll" data-reference="perso-projects">
                    <h2>${assets.get({
        name   : section_ico.perso_projects,
        'class': 'section-ico'
    }, 'img')}Projet personnel pour une utilisation professionnelle</h2>
                        <section class="experiences__experience">
                        
                        <h3>HIND (Framework JS)</h3>
                        ${get_duration_block("Depuis 05/2017")}
                        <p class="experiences__experience_tags">Mots-clés : <strong>JS ES6, Node.js, Webpack, SASS, API REST, NPX, GitHub</strong></p>
                        <p>Création d'un framework MVP isomorphe et en partie universel, codé en JavaScript ES6 (Local Forage / Promise / Node.js / Babel /
            Webpack) pour simplifier le développement d’application full JavaScript :</p>
            
                        <ul>
                            <li>Une couche applicative, un service d’injection de dépendances.</li>
                            <li>Création d’un gestionnaire de plugins (breadcrumb / ecommerce / …).</li>
                            <li>Extension pour écrire des routes de type API REST.</li>
                            <li>Orienté aussi pour l’UX et le design – Hooks synchronisés par Promise sur toutes les étapes
        de chargement de l’application, d’une route ou autre composant => liberté d’action complète
        sur les animations et les changements de vues.</li>
                            <li>Souplesse d’installation et de mise à jour via npm / npx.</li>
                            <li>Architecture SASS pour les styles.</li>
                        </ul>
                    </section>
                </article>
                <article id="freelance_xp" class="experiences__typeof trigger-on-scroll" data-reference="freelance-xp">
                    <h2>${assets.get({
        name   : section_ico.freelance_xp,
        'class': 'section-ico'
    }, 'img')}Expériences professionnelles – Auto-entrepreneur</h2>
                    
                    <section class="experiences__experience">
                        <h3>Yellow Korner</h3>
                        ${get_duration_block("01/2023 - 04/2023")}
                        <p class="experiences__experience_tags">Mots-clés : <strong>React, PHP, Twig, EvQueue, Gogs, Mailchimp API, SCSS</strong></p>
                        <p>Maintenance applicative du CRM de Yellow Korner.</p>
                        <p>Une conception maison et standardisée en accord avec les principes SOLID.</p>
                        <p>Des composants React rendent flexibles la conception en JS et facilitent l’expérience utilisateur (ainsi que l’UI) des
                        différentes interfaces. Twig est implémenté.
                        </p>
                        <p class="bold">Rôles :</p>
                        <ul>
                            <li><span class="bold">Corriger et faire évoluer l’outil:</span> ses interfaces, ses tâches automatisées, ses
                            fonctionnalités, ses appels à des API externes.
                            </li>
                            <li><span class="bold">Développement:</span> PHP, Twig, React, SCSS, Vanilla JS.</li>
                        </ul>
                    </section>
                    <section class="experiences__experience">
                        <h3><a target="_blank" class="external_link" href="https://fotokino.org/">Fotokino
                        ${get_external_link()}</a></h3>
                        ${get_duration_block("07/2022 - 11/2022")}
                        <p class="experiences__experience_tags">Mots-clés : <strong>Gestion de projet, WordPress, JavaScript, Webpack, Git, SCSS</strong></p>
                        <p>Refondre la totalité du code du site de l’association « Fotokino».</p>
                        <p>C'est une organisation qui diffuse des travaux artistiques dans le champs des arts visuels, qui organise des ateliers,
                        des rencontres spécifiquement auprès des plus jeunes.
                        </p>
                        <p>La démarche est de contribuer à la sensibilisation du regard, à l’éveil de l’esprit critique.
                        </p>
                        <p class="bold">Rôles :</p>
                        <ul>
                            <li>
                                Développement du site en tandem avec Fewzi Raffed qui se charge du graphisme, de l’intégration et de la gestion client.
                            </li>
                            <li><span class="bold">Gestion du projet:</span> Slack / Github.</li>
                            <li><span class="bold">Développement:</span> PHP, WordPress, Webpack pour les SCSS.</li>
                            <li><span class="bold">Installation serveur préproduction:</span> LAMP chez OVH.</li>
                        </ul>
                    </section>
                    <section class="experiences__experience">
                        <h3>Club Med</h3>
                        ${get_duration_block("02/2021 – 09/2022")}
                        <p class="experiences__experience_tags">Mots-clés : <strong>WordPress, JavaScript, Webpack, Git, Docker</strong></p>
                        <p>Faire évoluer et maintenir l’application « CMTA Travel Agents ». Un site de gestion des réservations à destination des agences partenaires du Club Med.</p>
                        <p>Participer à l’amélioration de la gestion des développements dans GIT, pour mieux organiser les différents MERGE, REBASE et déploiements / rollbacks.</p>
                        <p>Développement du site au sein d’une équipe de 3 fonctionnels et d’un développeur en début de mission. Quelques mois plus tard, nous étions 4 développeurs dont un lead dev.</p>
                        <p class="bold">Rôles :</p>
                        <ul>
                            <li><span class="bold">Développement:</span> PHP, WordPress, JavaScript, création d’un projet WebPack pour les SASS et JS</li>
                            <li>En charge de la documentation technique.</li>
                            <li>Garant de la qualité des codes produits en tandem avec le lead dev.</li>
                        </ul>
                        <p><span class="bold">Outils particuliers:</span> Teams / Figma / Github.</p>
                        <p><span class="bold">Environnement technique:</span> LEMP, Docker, Node.js, Jenkins.</p>
                    </section>
                    <section class="experiences__experience">
                        <h3><a target="_blank" class="external_link" href="https://quatuorpsophos.com/">Quatuor Psophos
                        ${get_external_link()}
                        </a></h3>
                        ${get_duration_block("12/2020 - 02/2021")}
                        <p class="experiences__experience_tags">Mots-clés : <strong>Gestion de projet, WordPress, JavaScript, Installation et sécurisation serveur LEMP et Node.js, Webpack, PM2, GIT</strong></p>
                        <p>Refondre l’UI et le socle technique du site de l’association « Les Amis du Quatuor Psophos ».</p>
                        <p>C'est une association composée de 4 musiciens qui forment donc un quatuor à corde.</p>
                        <p class="bold">Rôles :</p>
                        <ul>
                            <li>
                                Développement du site en tandem avec Fewzi Raffed qui se charge du graphisme et de l’intégration.
                            </li>
                            <li><span class="bold">Gestion de projet:</span> Slack / Jira / Confluence / Github.</li>
                            <li><span class="bold">Développement:</span> PHP, WordPress, interface en JavaScript sur un serveur Node.js avec <a href="#perso_projects">le framework HIND.</a></li>
                            <li><span class="bold">Installation serveur:</span> LAMP, LEMP et Node.js chez OVH.</li>
                        </ul>
                    </section>
                    <section class="experiences__experience">
                        <h3><a target="_blank" class="external_link" href="https://bootstrap-label.com/">Bootstrap Label
                        ${get_external_link()}</a>, le WIPP Festival
                        </h3>
                        ${get_duration_block("08/2020 - 11/2020")}
                        <p class="experiences__experience_tags">Mots-clés : <strong>Recrutement freelance, Gestion de projet / d’équipe, WordPress</strong></p>
                        <p>Créer les logos et les sites (sur-mesure) de la société Bootstrap Label - Une maison de
                        production de documentaires dans le cinéma – et du WIPP : le festival de cinéma
                        spécialisé en métrage en cours d’écriture, organisé par cette même société.
                        </p>
                        <p class="bold">Rôles :</p>
                        <ul>
                            <li>Accompagnement client et recrutement de deux profils en free-lance :
                            <p></p>
                            <ul>
                                <li>Une illustratrice et graphiste web / print pour le logo, la mise en page et le graphisme :
                                Mathilde Imbert.</li>
                                <li>Un graphiste et intégrateur : Fewzi Raffed.</li>
                            </ul>
                            </li>
                            <li><span class="bold">Analyse des données et conception:</span> Deux administrations WordPress qui collent
    simplement au plus près des besoins. Le minimum nécessaire en plugins.</li>
                            <li><span class="bold">Gestion de projet:</span> Slack / Jira / Confluence / Github / Adobe XD.</li>
                            <li><span class="bold">Développement:</span> PHP, WordPress, JavaScript.</li>
                            <li><span class="bold">Installation serveur:</span> LAMP chez Gandi.</li>
                        </ul>
                    </section>
                    <section class="experiences__experience">
                        <h3>Health Events
                        </h3>
                        ${get_duration_block("07/2020 - 08/2020")}
                        <p class="experiences__experience_tags">Mots-clés : <strong>Modélisation SQL, WordPress</strong></p>
                        <p>Refondre le système d'inscription à une session de formation de santé.
                        </p>
                        <p>Permettre le tracking des balises UTM au moment de l'inscription.</p>
                        <p>Remplir automatiquement une feuille « Google sheets ».</p>
                        <p class="bold">Rôles :</p>
                        <ul>
                            <li><span class="bold">Conception:</span> BDD (SQL).</li>
                            <li><span class="bold">Développement:</span> PHP, WordPress, JavaScript, Simple-DataTables.</li>
                        </ul>
                    </section>
                    <section class="experiences__experience">
                        <h3>Delphes Paris
                        </h3>
                        ${get_duration_block("01/2020 - 04/2020")}
                        <p class="experiences__experience_tags">Mots-clés : <strong>Conception applicative / API REST, WordPress, Stripe Payment, Installation et
    sécurisation serveur LAMP et Node.js</strong></p>
                        <p>Refonte UX et technique d'une plateforme e-commerce de vente de bijoux.
                        </p>
                        <p>Il est impératif de garder l’administration WordPress avec la boutique woocommerce..</p>
                        <p>Le besoin du client est de proposer une navigation fluide, une mise en page claire, un
    tunnel d’achat rapide et facile à utiliser, un paiement en ligne tout aussi facile à utiliser –
    l’ancien système étant, de préférence, à abandonner.</p>
                        <p class="bold">Rôles :</p>
                        <ul>
                            <li><span class="bold">Conception:</span> architecture applicative, conception API REST.</li>
                            <li><span class="bold">Développement:</span> PHP, WordPress API, Stripe, interface en JavaScript avec <a href="#perso_projects">le framework HIND.</a></li>
                            <li><span class="bold">Installation serveur:</span> LAMP et Node.js chez Gandi.</li>
                        </ul>
                    </section>
                    <section class="experiences__experience">
                        <h3>Investment Design and Patrimony
                        </h3>
                        ${get_duration_block("05/2019 - 04/2020")}
                        <p class="experiences__experience_tags">Mots-clés : <strong>Modélisation SQL / NoSQL, WordPress, Stripe Payment, Installation et
    sécurisation serveur LAMP, Mailjet API</strong></p>
                        <p>Conception et développement d'un espace privé pour déclarer ses locations meublées, sur
    une instance Wordpress.
                        </p>
                        <p class="bold">Rôles :</p>
                        <ul>
                            <li><span class="bold">Conception:</span> BDD (SQL / NoSQL), UX (espace privé sur mesure).</li>
                            <li><span class="bold">Développement:</span> PHP, WordPress, Stripe, JavaScript.</li>
                            <li><span class="bold">Installation serveur:</span> LAMP sur public cloud OVH.</li>
                        </ul>
                    </section>
                    <section class="experiences__experience">
                        <h3>Simonnot Avocat
                        </h3>
                        ${get_duration_block("08/2019 - 12/2019")}
                        <p class="experiences__experience_tags">Mots-clés : <strong>Modélisation SQL / NoSQL, WordPress, installation et sécurisation serveur
    LAMP</strong></p>
                        <p>Conception et programmation d'une application web pour gérer le cycle de vie d'une
    affaire de divorce par consentement mutuel.
                        </p>
                        <p class="bold">Rôles :</p>
                        <ul>
                            <li><span class="bold">Conception:</span> BDD (SQL / NoSQL), UX (espace privé sur mesure).</li>
                            <li><span class="bold">Développement:</span> PHP, WordPress, JavaScript.</li>
                            <li><span class="bold">Installation serveur:</span> LAMP sur cloud Gandi.</li>
                        </ul>
                    </section>
                    <section class="experiences__experience">
                        <h3>Typology
                        </h3>
                        ${get_duration_block("01/2019")}
                        <p class="experiences__experience_tags">Mots-clés : <strong>Micro-service PHP sur AWS Lambda</strong></p>
                        <p>Développement d’un micro service sur AWS Lambda.</p>
                        <p>Il réalise un certain nombre de
    fonctionnalités autour des codes et demandes d’invitations, ainsi que l’enregistrement de
    clients invités.
                        </p>
                        <p>Les informations sont envoyés par une boutique Shopify et traitées sur AWS.</p>
                        </p>
                        <p class="bold">Rôles :</p>
                        <ul>
                            <li><span class="bold">Développement:</span> PHP</li>
                        </ul>
                    </section>
                    <section class="experiences__experience">
                        <h3>Kameleos
                        </h3>
                        ${get_duration_block("09/2018 - 10/2018")}
                        <p class="experiences__experience_tags">Mots-clés : <strong>Encadrement technique, Node.js, intervention commando</strong></p>
                        <p>Évolutions et Debug sur la plateforme d’e-learning « Kameleos ».</p>
                        <p class="bold">Rôles :</p>
                        <ul>
                            <li><span class="bold">Encadrement:</span> Relecture des codes et conseils en bonnes pratiques auprès des deux développeurs juniors.</li>
                            <li><span class="bold">Développement:</span> Node.js, MongoDB.</li>
                        </ul>
                    </section>
                    <section class="experiences__experience">
                        <h3>Zeta Technologies
                        </h3>
                        ${get_duration_block("06/2018")}
                        <p class="experiences__experience_tags">Mots-clés : <strong>Modélisation de données, conception NoSQL et API REST, architecture
    applicative, intervention commando</strong></p>
                        <p>Réaliser les bases d’un système de gestion des données de patients souffrant
    d’acouphènes. Ils réalisent des exercices afin de les « gommer ».</p>
                        <p>Ce système doit pouvoir enregistrer de manière souple les exercices et les résultats.</p>
                        <p class="bold">Rôles :</p>
                        <ul>
                            <li><span class="bold">Conception:</span> NoSQL, REST API.</li>
                            <li><span class="bold">Développement:</span> Node.js, MongoDB.</li>
                        </ul>
                    </section>
                    <section class="experiences__experience">
                        <h3>RedPill
                        </h3>
                        ${get_duration_block("04/2018 - 05/20188")}
                        <p class="experiences__experience_tags">Mots-clés : <strong>Conception DynamoDB et API REST, Node.js, AWS LAMBDA, Configuration via
    Serverless</strong></p>
                        <p>Réaliser la base d’un système permettant de simuler selon divers calculs l’intérêt de
    souscrire ou non à l’assurance emprunteur du partenaire de mon client sur ce projet.</p>
                        <p>Le système prend aussi en charge l’inscription et la génération du contrat.</p>
                        <p class="bold">Rôles :</p>
                        <ul>
                            <li><span class="bold">Conception:</span> NoSQL, REST API.</li>
                            <li><span class="bold">Développement:</span> Api en JavaScript sur Node.js, BDD DynamoDB. Le tout configuré via
    Serverless et envoyé sur AWS LAMBDA.</li>
                        </ul>
                    </section>
                    <section class="experiences__experience">
                        <h3>EpressPack
                        </h3>
                        ${get_duration_block("09/2017 - 02/2018")}
                        <p class="experiences__experience_tags">Mots-clés : <strong>Formation, encadrement technique, thème WordPress, intervention pompier</strong></p>
                        <p>Venir en renfort sur la maintenance sur plugin contenant le système principal du produit de
    cet agence.</p>
                        <p>Refondre les développements WordPress pour les rendre plus maintenables et
    modulables.</p>
                        <p>Encadrer, former et aider toutes les équipes de développements.</p>
                        <p class="bold">Rôles :</p>
                        <ul>
                            <li><span class="bold">Encadrement:</span> Former les développeurs juniors à la POO et au nouveau système de
    thème (sur mesure) technique WordPress. Les faire progresser en programmation et en
    algorithme. Documentation des composants PHP / JavaScript produits.</li>
                            <li><span class="bold">Conception:</span> architecture de codes modulables, génériques. Séparation en composants.</li>
                            <li><span class="bold">Développement:</span> PHP, WordPress, JavaScript.</li>
                        </ul>
                    </section>
                    <section class="experiences__experience">
                        <h3>Mahi Mahi
                        </h3>
                        ${get_duration_block("11/2017 - 01/2018")}
                        <p class="experiences__experience_tags">Mots-clés : <strong>Modélisation de données, conception API REST, WordPress API</strong></p>
                        <p>Concevoir une API pour piloter une application d’aide aux personnes âgées dans certains
    pays de l’Union Européenne.</p>
                        <p>L’application est un WordPress multi-site. Je viens donc concevoir une API venant
    surcharger celle de base intégrée dans ce CMS.</p>
                        <p class="bold">Rôles :</p>
                        <ul>
                            <li><span class="bold">Conception:</span> REST API avec Postman. Analyse complète de la base de données de
    l’application (Modèle de données de BuddyPress) pour en retirer une API.</li>
                            <li><span class="bold">Développement:</span> PHP, WordPress.</li>
                        </ul>
                    </section>
                </article>
                <article id="employee_xp" class="experiences__typeof experiences__typeof__employee trigger-on-scroll" data-reference="employees-xp">
                    <h2>${assets.get({
        name   : section_ico.employee_xp,
        'class': 'section-ico'
    }, 'img')}Expériences professionnelles – Employé</h2>

                    <section class="experiences__experience">
                        <h3>RESA Airport Data Systems
                        </h3>
                        ${get_duration_block("03/2026 - 06/2026")}
                        <p class="experiences__experience_tags">Mots-clés : <strong>GIT, C#, SQL Server, DevExtreme, React.js, TypeScript, API RESTful, SCSS, Copilot</strong></p>
                        <p>
                            <span class="bold">Objectif:</span> Maintenance et évolution de la plateforme de communication interne entre Resa et ses clients.
                            <br />
                            <br />
                            Cette plateforme est un outil de gestion des tickets, du fond documentaire et de l’inventaire des données de référence de l’entreprise (pays, compagnies aériennes, périphériques comme les portes d’embarquement, les produits RESA mis en service, les contacts).
                        </p>
                        <p class="my-result"><span class="bold">Résultat:</span> De par mes actions, le fond documentaire de l’ensemble des produits de RESA est maintenant facilement administrable, permettant alors aux clients d’y accéder.</p>
                        <p><span class="bold">Organisation :</span></p>
                        <ul>
                            <li>Mise en place de la relecture des codes.</li>
                            <li>Écriture des spécifications  et des scénarios de tests fonctionnels.</li>
                            <li>Organisation du projet GIT pour une meilleure gestion des sources, des PR, des déploiements en test, des mises en production et des rollbacks.</li>
                            <li>Évolution des pipelines CI/CD.</li>
                        </ul>
                        <p><span class="bold">Conception:</span> Création de composants ReactJS et d’une gestion fine des états et actions entre ReactJS et DevExtreme ReactJS.</p>
                        <p><span class="bold">Développement:</span> C#, SQL Server (Fonctions et procédures stockées), ReactJS, TypeScript, SCSS.</p>
                        <p><span class="bold">Outils particuliers:</span> Microsoft Copilot, Visual Studio, DevExtreme React, Microsoft Azure, SQL Server Manager, Microsoft Azure.</p>
                    </section>                    
                    <section class="experiences__experience">
                        <h3>MKI - IMMOLEAD
                        </h3>
                        ${get_duration_block("06/2024 - 02/2025")}
                        <p class="experiences__experience_tags">Mots-clés : <strong>GIT, PHP, SQL, JQuery, JavaScript, CSS, OpenAI, CKEditor5</strong></p>
                        <p><span class="bold">Organisation:</span> Mise en place de la relecture des codes au sein de l’équipe des développeurs. Sensibilisation pour mieux organiser le projet GIT de IMMOLEAD CRM.</p>
                        <p><span class="bold">Conception :</span></p>
                        <ul>
                            <li>Études et applications de certains Design Patterns pour refondre techniquement certaines parties du CRM (gestion de la communication entre un agent immobilier et un contact: note, email, sms...).</li>
                            <li>Création de composants dont :</li>
                            <ul>
                                <li>Un manager pour piloter CKEditor5 facilement dans le CRM.</li>
                                <li>
                                    Un manager pour piloter facilement des outils d’analyse de documents et
                                    de générations de contenus spécifiques – le tout avec OpenAI - depuis
                                    l’interface du CRM.
                                </li>
                                <li>Rédaction des documentations techniques et fonctionnelles de ces composants.</li>
                            </ul>
                        </ul>
                        <p><span class="bold">Développement:</span>  PHP, JavaScript Vanilla, SQL.</p>
                        <p><span class="bold">Outils particuliers:</span> OpenAI API, CKEditor5.</p>
                    </section>
                    <section class="experiences__experience">
                        <h3>Jackson & Kent
                        </h3>
                        ${get_duration_block("04/2017 - 05/2017")}
                        <p><span class="bold">Développement:</span> PHP (Laravel, Phalcon, PHP UNIT), JavaScript ES, MongoDB.</p>
                    </section>
                    <section class="experiences__experience">
                        <h3>Awak'IT
                        </h3>
                        ${get_duration_block("10/2015 - 10/2016")}
                        <p><span class="bold">Conception:</span> analyse de brief, analyse fonctionnelle, conseil technique, création de wireframes.</p>
                        <p><span class="bold">Encadrement:</span> Veille technique, encadrement des développements sur WordPress, optimisations
    des architectures pour l’intégration continue avec Jenkins (création de build), suivi de l’évolution
    des développements en général.</p>
                        <p><span class="bold">Développement:</span> PHP, WordPress, JavaScript.</p>
                    </section>
                    <section class="experiences__experience">
                        <h3>Altedis
                        </h3>
                        ${get_duration_block("02/2015 - 10/2015")}
                        <p><span class="bold">Intégration & développement front-End:</span> CSS, JavaScript.</p>
                    </section>
                    <section class="experiences__experience">
                        <h3>TimmXware
                        </h3>
                        ${get_duration_block("01/2014 - 12/2014")}
                        <p><span class="bold">Encadrement:</span> Rédaction d’un document de recommandations sur les optimisations des codes et
    de la BDD, sécurisation d’une instance WordPress.</p>
                        <p><span class="bold">Conception:</span> Modélisation UML (flux de données, diagramme d’action, scénarios), wireframes,
    analyse de brief / fonctionnelle, algorithmie.</p>
                        <p><span class="bold">Développement:</span> PHP, WordPress, JavaScript.</p>
                    </section>
                    <section class="experiences__experience">
                        <h3>Alter Way
                        </h3>
                        ${get_duration_block("09/2012 - 01/2014")}
                        <p><span class="bold">Référencement:</span> Netlinking, sitemap, plan de taggage, plan de tracking dans les newsletters
    suivies d’analyses des résultats et recommandations, recherche de mots-clés utiles pour tel
    projet.</p>
                        <p><span class="bold">Développement:</span> PHP, WordPress, JavaScript, Twig (plugin Timber Twig sur WordPress), recette
    fonctionnelle et technique, LESS.</p>
                    </section>
                    <section class="experiences__experience">
                        <h3>Masha Design & Conseils
                        </h3>
                        ${get_duration_block("09/2010 - 08/2012")}
                        <p><span class="bold">Conseil et encadrement:</span> Réunions de projets, recueil des besoins, conseil technique pour les
    clients.</p>
                        <p><span class="bold">Conception:</span> architecture des codes, modélisation de données.</p>
                        <p><span class="bold">Développement:</span> PHP, WordPress, JavaScript, CSS.</p>
                    </section>
                </article>
            </div>
            <article id="schooling" class="trigger-on-scroll" data-reference="schooling">
                <h2>${assets.get({
        name   : section_ico.schooling,
        'class': 'section-ico'
    }, 'img')}Formations</h2>
                
                <div class="schooling">
                    <div class="timeline">
                        <div class="timeline__item">
                          <div class="timeline__item__content">
                            <div class="timeline__item__content__timeline-date">2025</div>
                            <div class="timeline__item__content__timeline-description">ILAC Toronto - Cours d’anglais terminés au niveau C2 après avoir réussi le C1.</div>
                          </div>
                        </div>
                        <div class="timeline__item">
                          <div class="timeline__item__content">
                            <div class="timeline__item__content__timeline-date">2012</div>
                            <div class="timeline__item__content__timeline-description">Licence professionnelle ACSID - CNAM</div>
                          </div>
                        </div>
                        <div class="timeline__item">
                          <div class="timeline__item__content">
                            <div class="timeline__item__content__timeline-date">2010</div>
                            <div class="timeline__item__content__timeline-description">D.U.T informatique - Orsay</div>
                          </div>
                        </div>
                        <div class="timeline__item">
                          <div class="timeline__item__content">
                            <div class="timeline__item__content__timeline-date">2006</div>
                            <div class="timeline__item__content__timeline-description">BAC S.T.I. électronique</div>
                          </div>
                        </div>
                    </div>
                </div>
            </article>
            <article id="perso_activities" class="trigger-on-scroll" data-reference="perso-activities">
                <h2>${assets.get({
        name   : section_ico.perso_activities,
        'class': 'section-ico'
    }, 'img')}Centres d'intérêts et activités personnelles</h2>
                <div class="perso-activities">
                    <h3>Cinéma</h3>
                    <p>Intérêt pour le cinéma underground, d'exploitation et fantastique.</p>
                    <hr>
                    <h3>Musique</h3>
                    <p>10 ans de tuba et d'orchestre harmonique.</p>
                    <p>DJ – conception de mix.</p>
                    <hr>
                    <h3>Théâtre</h3>
                    <p>Improvisation : cours, ateliers et scènes ouvertes.</p>
                    <hr>
                    <h3>Photographie</h3>
                    <p>Portraits de gens dans la rue.</p>
                    <p>Paysages urbains.</p>
                    <p>Traitement numérique.</p>
                    <hr>
                    <h3>Associatif</h3>
                    <p>Propose des coups de main à des associations en auto-gestion œuvrant sur ces terrains :
    cantines, agriculture, festivals punks.</p>
                </div>
            </article>
        </section>
        `;
};

const get_my_photo_content = () => {
    if (!Config_view.get().is_open_to_work) {
        /*return assets.get({
            name: "my-photo.png",
            alt : "Photo de Matthieu Barbaresco"
        }, "img");*/

        return `
            <div class="flag-open-to-work">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                    <defs>
                        <filter id="drop-shadow">
                            <feDropShadow dx="0.2" dy="0.4" stdDeviation="0.2" />
                        </filter>
                    </defs>
                    
                    <clipPath id="circlePathImg">
                        <circle cx="50%" cy="50%" style="" fill="none" r="37%"></circle>
                    </clipPath>
                 
                    <g filter="url(#drop-shadow)" style="clip-path:url(#circlePathImg)">
                        <image width="100" height="100" transform="" href="${assets_url}my-photo.png" />
                    </g>
            </svg>
        </div>
        `;
    }

    return `
        <div class="flag-open-to-work">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                <defs>
                    <filter id="drop-shadow">
                        <feDropShadow dx="0.2" dy="0.4" stdDeviation="0.2" />
                    </filter>
                </defs>
                
                <path id="circlePathText" d="M5,50a40,40 0 0,0 86,3a44,45 0 0,0 -85,0" fill="none" />
                
                <clipPath id="circlePathImg">
                    <circle cx="50%" cy="50%" style="" fill="none" r="37%"></circle>
                </clipPath>
                
                <text x="-5">
                    <textPath href="#circlePathText" fill="#01D758">
                      #Open to work
                    </textPath>
                </text>
                
                <g filter="url(#drop-shadow)" style="clip-path:url(#circlePathImg)">
                    <image width="100" height="100" transform="" href="${assets_url}my-photo.png" />
                </g>
            </svg>
        </div>
    `;
}